// extracted by mini-css-extract-plugin
module.exports = {"table":"_2O8ntL-JHSv8","service__name":"_38PnAWZMacsM","service__price":"_9iFSn-TkoiQD","service__rfisc":"Ik20z7Yvmw63","selected":"_2oncYGUlMoYr","action":"_23ztUqQqN72X"};